import React, { useEffect } from "react";
import {
    Switch,
    Route,
    Redirect,
    useRouteMatch,
    useLocation,
} from "react-router-dom";

import { Box } from "@mui/system";

import BreadCrumbs from "../components/Breadcrumbs";
import LibrarySidebar from "../components/library/LibrarySidebar";
import { useDispatch, useSelector } from "react-redux";
import { setTemplates } from "../store/actions/contract";
import LibraryMasterContracts from "../components/library/LibraryMasterContracts";
import MasterContractDatails from "../components/library/MasterContractDatails";

function Library() {
    const { url } = useRouteMatch();
    const { pathname } = useLocation();
    const {
        user: { _id },
    } = useSelector((state) => state.user);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(setTemplates(_id));
    }, [dispatch, _id]);

    return (
        <Box
            sx={{ minHeight: "78vh", margin: "0 auto", width: "100%" }}
            maxWidth={pathname.split("/").at(-1) === "copy" ? "md" : "lg"}
        >
            <BreadCrumbs
                breadCrumbTitle="Library"
                crumbs={pathname.split("/")}
            />
            <Box sx={{ display: "flex", justifyContent: "center" }}>
                {pathname.split("/").at(-3) !== "master-contract" && (
                    <LibrarySidebar />
                )}
                <Switch>
                    <Route path={`${url}/nft/:filter`}>
                        <LibraryMasterContracts />
                    </Route>
                    <Route path={`${url}/master-contract/:contractID`}>
                        <MasterContractDatails />
                    </Route>

                    <Route path={`${url}`}>
                        <Redirect to={`${url}/nft/all`} />
                    </Route>
                </Switch>
            </Box>
        </Box>
    );
}

export default Library;
